export const isServerSide = typeof document === 'undefined';
